<template>
  <el-button type="primary" size="mini" @click="childclick" icon="el-icon-close">
    <slot>关闭</slot>
  </el-button>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    ...mapState(['tabsRouter'])
  },
  methods: {
    ...mapMutations(['DEL_TABROUTER']),
    childclick() {
      this.$emit('click');
      this.DEL_TABROUTER({ path: this.$route.path });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>